// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"60075eb4","703":"11371b59","787":"8675c87a"}[chunkId] + ".chunk.js";
};